module.exports = __webpack_public_path__ + "img/pieceOneImg5.a0c2483.png";